import { LocalShippingOutlined } from '@mui/icons-material';
import { alpha, Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MODULE_ACCENT_COLORS } from '../../../../theme/module-colors';
import { formatDateShortMonth } from '../../../../utils/date-formatter';

const accent = MODULE_ACCENT_COLORS.goodsReceiving.main;

interface SummaryMastheadProps {
  supplierName: string | null;
  documentNumber: string | null;
  documentDate: string | null;
}

export function SummaryMasthead({
  supplierName,
  documentNumber,
  documentDate,
}: SummaryMastheadProps) {
  const { t } = useTranslation('goodsReceiving');

  const metaParts = [
    documentNumber ? `${t('documentNumberLabel')} ${documentNumber}` : null,
    documentDate ? formatDateShortMonth(documentDate) : null,
  ].filter(Boolean);

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: 1,
        borderColor: alpha(accent, 0.2),
        background: `linear-gradient(135deg, ${alpha(accent, 0.12)}, ${alpha(accent, 0.03)})`,
      }}
    >
      <Stack direction="row" spacing={1.75} sx={{ alignItems: 'flex-start' }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: accent,
            color: '#fff',
            boxShadow: `0 6px 16px ${alpha(accent, 0.35)}`,
          }}
        >
          <LocalShippingOutlined />
        </Box>

        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="body2"
            sx={{ color: alpha(accent, 0.95), fontWeight: 600, mb: 0.25 }}
          >
            {t('summaryDocType')}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              color: 'text.primary',
              overflowWrap: 'anywhere',
            }}
          >
            {supplierName || t('documentSupplier')}
          </Typography>
          {metaParts.length > 0 && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
              {metaParts.join('  ·  ')}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
